let vm = null;
export function sendThis(_this) {
  vm = _this;
}

export const selectionColumn = [
  {
    type: 'selection',
    width: 60,
    align: 'center',
    fixed: 'left'
  }
];
const baseColumn = [
  {
    title: '序号',
    key: 'number',
    width: 120,
    align: 'center',
    fixed: 'left'
  },
  {
    title: '服务学校',
    key: 'schoolName',
    minWidth: 200,
    align: 'center',
    fixed: 'left'
  }
];

const moneyColumn = [
  {
    title: '材料费',
    key: 'attachmentPrice',
    minWidth: 120,
    align: 'center'
  },
  {
    title: '素质课程费',
    key: 'classroomFee',
    minWidth: 120,
    align: 'center'
  },
  {
    title: '合计金额',
    key: 'totalFee',
    minWidth: 160,
    align: 'center'
  }
];

const daycareColumn = [
  {
    title: '午托费',
    key: 'noonCare',
    minWidth: 120,
    align: 'center'
  },
  {
    title: '基本托管费',
    key: 'lateCare',
    minWidth: 120,
    align: 'center'
  },
  {
    title: '晚自修费用',
    key: 'fullCare',
    minWidth: 120,
    align: 'center'
  }
];

const platServiceFeeColumn = [
  {
    title: '平台服务费',
    key: 'platServiceFee',
    width: 150,
    align: 'center'
  }
];
const platServiceFeeRenderHeader = (h, params) => {
  return h(
    'Tooltip',
    { props: { placement: 'top', transfer: true, 'max-width': '300' }}, // 提示组件的属性
    [
      h('span', [
        h('span', '平台服务费'), // 列名
        h('Icon', { props: { type: 'ios-alert-outline' }}) // 问号图标
      ]),
      h(
        'span',
        {
          slot: 'content'
        },
        '账单的结算订单中结算部分平台对应的服务费之和（含手续费部分）。'
      ) // 提示内容
    ]
  );
};

const totalChannelAmtColumn = [
  {
    title: '手续费(机构方)',
    key: 'totalChannelAmt',
    minWidth: 150,
    align: 'center'
  }
];
export const merchantCommission = [
  {
    title: '手续费(机构)',
    key: 'merchantCommission',
    width: 150,
    align: 'center'
  }
];
const otherColumn = [
  ...platServiceFeeColumn,
  {
    title: '机构应结算金额',
    key: 'totalDivideAmt',
    minWidth: 150,
    align: 'center'
  }
];

const monthColumn = [
  {
    title: 'Other',
    align: 'center',
    children: [
      {
        title: '午托费',
        key: 'noonCareAmt',
        width: 120,
        align: 'center'
      },
      {
        title: '基本托管费',
        key: 'lateCareAmt',
        align: 'center',
        width: 120
      },
      {
        title: '晚自修费用',
        key: 'fullCareAmt',
        width: 120,
        align: 'center'
      },
      {
        title: '材料费',
        key: 'attachmentPrice',
        align: 'center',
        width: 120
      },
      {
        title: '课程费',
        key: 'classroomFee',
        align: 'center',
        width: 120
      },
      {
        title: '合计金额',
        key: 'settleAvailAmt',
        align: 'center',
        width: 150
      },
      {
        title: '平台服务费',
        key: 'platAmt',
        align: 'center',
        width: 150
      },
      {
        title: '机构应结算金额',
        key: 'merchantAmt',
        align: 'center',
        width: 150
      }
    ]
  },
  {
    title: '机构核对',
    slot: 'orgCheck',
    width: 120,
    align: 'center'
  },
  {
    title: '审批状态',
    slot: 'approvalEduSts',
    width: 120,
    align: 'center'
  },
  // {
  //   title: '预审',
  //   slot: 'unionCheck',
  //   width: 120,
  //   align: 'center'
  // },
  // {
  //   title: '教育局复审',
  //   slot: 'eduCheck',
  //   width: 120,
  //   align: 'center'
  // },

  {
    title: '结算状态',
    slot: 'settleSts',
    width: 120,
    align: 'center'
  },
  {
    title: '结算时间',
    key: 'settleTime',
    width: 120,
    align: 'center'
  }

  // {
  //   title: '操作',
  //   slot: 'action',
  //   minWidth: 120,
  //   align: 'center',
  //   fixed: 'right'
  // }
];

const tallyCountColumn = [
  {
    title: '结算笔数',
    key: 'tallyCount',
    width: 100,
    align: 'center'
  }
];

const actionColumn = [
  {
    title: '操作',
    slot: 'action',
    minWidth: 120,
    align: 'center',
    fixed: 'right',
    renderHeader: (h, params) => {
      const handleFilter = () => {
        vm.handleShowActionModal();
      };
      return h(
        'div',
        {
          style: {
            display: 'flex',
            alignItems: 'center'
          }
        },
        [
          h('span', ['操作']),
          h('Icon', {
            on: {
              // 单元格的点击事件
              click: handleFilter
            },
            style: { marginLeft: '8px', cursor: 'pointer' },
            props: {
              type: 'ios-settings-outline',
              size: 22,
              color: '#ccc'
            }
          })
        ]
      );
    }
  }
];

// 操作- 查看明细
const actionListColumn = [
  {
    title: '操作',
    slot: 'actionList',
    width: 120,
    align: 'center',
    fixed: 'right',
    renderHeader: (h, params) => {
      const handleFilter = () => {
        vm.handleShowActionModal();
      };
      return h(
        'div',
        {
          style: {
            display: 'flex',
            alignItems: 'center'
          }
        },
        [
          h('span', ['操作']),
          vm.tableType != 2
            ? h('Icon', {
              on: {
                // 单元格的点击事件
                click: handleFilter
              },
              style: { marginLeft: '8px', cursor: 'pointer' },
              props: {
                type: 'ios-settings-outline',
                size: 22,
                color: '#ccc'
              }
            })
            : ''
        ]
      );
    }
  }
];
// 学校确认单表头
function getSchColumn() {
  return [
    {
      title: '序号',
      key: 'number',
      width: 80,
      align: 'center',
      fixed: 'left'
    },
    {
      title: '课程提供方',
      key: 'orgName',
      minWidth: 200,
      align: 'center',
      fixed: 'left'
    },
    {
      title: '收款单位',
      key: 'settlementSheetOrgName',
      minWidth: 200,
      align: 'center',
      fixed: 'left'
    },
    {
      title: '午托费',
      key: 'noonCareAmt',
      width: 120,
      align: 'center'
    },
    {
      title: '基本托管费',
      key: 'lateCareAmt',
      width: 120,
      align: 'center'
    },
    {
      title: '晚自修费用',
      key: 'fullCareAmt',
      width: 120,
      align: 'center'
    },
    {
      title: '材料费',
      key: 'attachmentPrice',
      width: 120,
      align: 'center'
    },
    {
      title: '素质课程费',
      key: 'classroomFee',
      width: 120,
      align: 'center'
    },
    {
      title: '合计金额',
      key: 'settleAvailAmt',
      width: 160,
      align: 'center'
    },
    {
      title: '平台服务费',
      key: 'platAmt',
      width: 160,
      align: 'center'
    },
    {
      title: '对账状态',
      slot: 'approvalSts',
      width: 120,
      align: 'center',
      fixed: 'right'
    }
  ];
}
// 教育局结算表格
function getEduColumn() {
  const column = JSON.parse(JSON.stringify(baseColumn));
  column[1]['title'] = '机构名称';
  column[1]['key'] = 'orgName';
  column[0]['fixed'] = 'left';
  column[1]['fixed'] = 'left';
  return [...column, ...monthColumn];
}

const mapData = {
  1: [
    ...baseColumn,
    ...daycareColumn,
    ...moneyColumn
    // ...otherColumn,
    // ...totalChannelAmtColumn
  ], // 机构
  2: getSchColumn(), // 学校
  3: getEduColumn(),
  4: [
    ...baseColumn,
    ...daycareColumn,
    ...moneyColumn,
    // ...tallyCountColumn,
    ...otherColumn,
    ...totalChannelAmtColumn
  ] // 运营端  机构 or 教育局 --机构结算单
};
// 指定 字段 删除表头
export function deleteColFun(targets = [], columns) {
  console.log('columns', columns);
  targets.forEach((target) => {
    const key = columns.findIndex((col) => {
      return col.key === target;
    });

    key != -1 && columns.splice(key, 1);
  });
}

export function getColumn(key = 1, opt = null) {
  let column = JSON.parse(JSON.stringify(mapData[key]));
  console.log(column, '拿到的表头----');
  // type :1  教育局 月结算单 更改表头问题
  if (opt && opt.type == 1) {
    opt.children.forEach((item) => {
      const arr = column.filter((col) => {
        return col.title === item.title;
      });
      if (arr.length) {
        arr[0]['title'] = item.value;
      }
    });
  }
  // type :4  运营端 教育局  教育局审批单  更改表头问题 添加 手续费
  if (opt && opt.type == 4) {
    opt.children.forEach((item) => {
      const arr = column.filter((col) => {
        return col.title === item.title;
      });
      if (arr.length) {
        arr[0]['title'] = item.value;
      }
    });
    column.forEach((item) => {
      if (item.children) {
        item.children.push({
          title: '手续费(合计)',
          key: 'commission',
          align: 'center',
          width: 150
        });
      }
    });
  }
  // type:2 查看明细
  if (opt && opt.type == 2) {
    column = [...column, ...actionListColumn];
  }

  // 平台服务费表头 要增加 展示注释
  column.forEach((item) => {
    if (item.key === 'platServiceFee') {
      // item.renderHeader = platServiceFeeRenderHeader
    }
  });
  if (key == 3) {
    column = [...column, ...actionColumn];
  }
  // 平安银行 ，删除表头
  // if (opt && opt.bankId == 1) {
  //   deleteColFun(['platServiceFee'], column);
  // }
  return column;
}
